/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/lines-between-class-members */
import { getLocalValue } from "../../storage";
import { STORAGE_KEY_ACCESS_TOKEN } from "../../authorization/Authorization";

interface FileDownloadResponse {
    contentType: string;
    fileData: string;
}

export const CATEGORY_AUTHORIZATION = "signin/portal";
export const CATEGORY_PORTAL = "portal";
const API_VERSION = "v1";

export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_NO_CONTENT = 204;
export const HTTP_STATUS_BAD_REQUEST = 400;
export const HTTP_STATUS_UNAUTHORIZED = 401;
export const HTTP_STATUS_FORBIDDEN = 403;
export const HTTP_STATUS_SERVER_ERROR = 500;

export const ERROR_MESSAGE_UNEXPECTED = "ERROR_UNEXPECTED";
export const ERROR_MESSAGE_TOKEN_INVALID = "ERROR_TOKEN_INVALID";
export const isTokenError = (error: unknown) => {
    if (!error) return false;
    if (error instanceof Error) {
        const { message } = error;
        return message === ERROR_MESSAGE_TOKEN_INVALID;
    }
    return false;
};

class FetchBase {
    private category: string;
    private url: string;
    private useToken: boolean;

    constructor(category: string, url: string, useToken?: boolean) {
        this.category = category;
        this.url = url;
        this.useToken = useToken !== undefined ? useToken : true;
    }

    private resolveURL(): string {
        return `${process.env.REACT_APP_API_URL_BASE}/${this.category}/${API_VERSION}/${this.url}`;
    }

    private getHeaders(): HeadersInit {
        const headers: HeadersInit = [
            ["Content-Type", "application/json;charset=UTF-8"],
            ["Access-Control-Allow-Origin", "*"],
            ["credentials", "include"],
            ["mode", "cors"],
        ];
        if (this.useToken) {
            const token = getLocalValue(STORAGE_KEY_ACCESS_TOKEN);
            // console.log("token", token);
            headers.push(["Authorization", `Bearer ${token}`]);
        }
        return headers;
    }

    protected async fetchBase(request: RequestInit): Promise<Response> {
        const url = this.resolveURL();
        return fetch(url, request).then(this.errorHandler);
    }

    protected async errorHandler(response: Response): Promise<Response> {
        const { status } = response;
        if (response.ok && (status === HTTP_STATUS_OK || status === HTTP_STATUS_NO_CONTENT)) {
            return response;
        }

        const json = await response.json();
        switch (status) {
            case HTTP_STATUS_UNAUTHORIZED:
            case HTTP_STATUS_FORBIDDEN:
                throw Error(ERROR_MESSAGE_TOKEN_INVALID);

            case HTTP_STATUS_BAD_REQUEST:
                const message = (json.errors || []).map((e: any) => `${e.item}: ${e.detail}`).join("\n");
                throw Error(message);

            default:
                throw Error(ERROR_MESSAGE_UNEXPECTED);
        }
    }

    protected async get(): Promise<Response> {
        const headers: HeadersInit = this.getHeaders();
        return this.fetchBase({
            method: "GET",
            headers,
        });
    }

    protected async post(payload?: object | undefined): Promise<Response> {
        const headers: HeadersInit = this.getHeaders();

        const body = JSON.stringify(payload || {});
        return this.fetchBase({
            method: "POST",
            headers,
            body,
        });
    }

    protected toJSON(response: Response): Promise<unknown> {
        const { status } = response;
        switch (status) {
            case HTTP_STATUS_OK:
                return response.json();
            default:
                return new Promise((resolve) => {
                    resolve({});
                });
        }
    }

    public async getJSON(resolved: (json: any) => void, rejected: (error: any) => void) {
        try {
            await this.get().then(this.toJSON).then(resolved);
        } catch (error: any) {
            rejected(error);
        }
    }

    public async postJSON(payload: object | undefined, resolved: (json: any) => void, rejected: (error: any) => void) {
        try {
            await this.post(payload).then(this.toJSON).then(resolved);
        } catch (error: any) {
            rejected(error);
        }
    }

    protected async getDownloadFile(resolved: (base64Text: string) => void, rejected: (error: any) => void) {
        try {
            await this.getJSON((json: any) => {
                const response = json as FileDownloadResponse;
                const base64Text = response.fileData ? `data:${response.contentType};base64,${response.fileData}` : "";
                resolved(base64Text);
            }, rejected);
        } catch (error: any) {
            rejected(error);
        }
    }

    protected async postDownloadFile(payload: object, resolved: (base64Text: string) => void, rejected: (error: any) => void) {
        try {
            await this.postJSON(
                payload,
                (json: any) => {
                    const response = json as FileDownloadResponse;
                    const base64Text = response.fileData ? `data:${response.contentType};base64,${response.fileData}` : "";
                    resolved(base64Text);
                },
                rejected
            );
        } catch (error: any) {
            rejected(error);
        }
    }

    protected async postWithPromise(payload: any): Promise<any> {
        return this.post(payload).then(this.toJSON);
    }

    protected async getWithPromise(): Promise<any> {
        return this.get().then(this.toJSON);
    }
}

export default FetchBase;
